// Auth Store LocalStorage Keys
export const AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  USER_ID: 'userId',
  USER: 'user',
} as const

// Mapping from localStorage keys to state property names
export const STORAGE_TO_STATE_MAP = {
  [AUTH_STORAGE_KEYS.ACCESS_TOKEN]: 'token',
  [AUTH_STORAGE_KEYS.USER_ID]: 'userId',
} as const
